$(function(){

	var
	    $timeoutModal = $('#sessionTimeoutWarningModal'),
		timeoutCookieName = "vit_portal_timeout__client",
		intervalToCheck = 5000, // every 5 seconds
	    timeToWarnMS = 1140000, // 19 minutes
		timeToLogoutMS = 1200000, // 20 minutes
		timeoutModalOpen = false,
		cookieRefreshed = true,
		cookieStartClient = null,
		userIsActive = false,
		aodaHandlerIntervalId;

	// clear session
    var timeInMS = new Date().getTime();
    //alert(timeInMS);
    cookieStartClient = timeInMS;
    document.cookie=timeoutCookieName + "=" + timeInMS.toString() + ";secure; " + "path=/";
    //alert(document.cookie);

	// update timeout cookie but no more than once every 500ms
	var updateCookieLimited = _.throttle(function() {
		if (! timeoutModalOpen) {
			var timeInMS = new Date().getTime();
			timeInMS = timeInMS.toString();
            cookieStartClient = timeInMS;
			document.cookie = timeoutCookieName + "=" + timeInMS + "; " + "path=/";
            userIsActive = true;

			$(window).trigger('module:site_timeout:notify', {sessionStatus: userIsActive});
		}
	}, 500);

    window.setInterval(function() {
	    requestSessionProlongation();
    }, 300000);

	checkSessionAge(intervalToCheck, timeToWarnMS, timeToLogoutMS);

	// listen for user interactions to refresh cookie
	$(document).on('scroll resize touchstart click update-session-cookie', updateCookieLimited);
    //updateCookieLimited();

	// Continue > close modal and refresh timeout cookie
	$timeoutModal.find('.js-yes').click(function (event) {
        userIsActive = true;
		requestSessionProlongation();

		event.preventDefault();
		var timeInMS = new Date().getTime();
		timeInMS = timeInMS.toString();
        cookieStartClient = timeInMS;
		document.cookie=timeoutCookieName + "=" + timeInMS + "; " + "path=/";
		$timeoutModal.modal('hide');
		checkSessionAge(intervalToCheck, timeToWarnMS, timeToLogoutMS);
		cookieRefreshed = true;
		timeoutModalOpen = false;
	});

	$timeoutModal.find('.js-no').click(function() {
		detachAodaHandlers();
		ga('send','event','Session Timeout', 'click logout');

	});

	$timeoutModal
		.on('shown.bs.modal', function () {
			attachAodaHandlers();
		})
		.on('hidden.bs.modal', function () {
			detachAodaHandlers();
		});

    $timeoutModal.appendTo($('body'));

	function checkSessionAge (checkInterval, warningTimeMS, logoutTimeMS) {
        var
            checkWarningTimeout,
            checkLogoutTimeout;

        checkWarningTimeout = function(checkInterval, warningTimeMS, logoutTimeMS) {
            var warnOfTimer = setTimeout (function (){
                var cookieTime = getCookieValue(timeoutCookieName);
                var cookieAge = getCookieAge(cookieTime);

                //console.log(cookieAge, warningTimeMS)
                if((warningTimeMS - cookieAge) / 1000 < 40) {
	                requestSessionProlongation();
                }

                if (cookieAge >= warningTimeMS) {
                    clearTimeout(warnOfTimer);
                    warnOfTimeout(warningTimeMS, logoutTimeMS);
                } else {
                    checkWarningTimeout(checkInterval, warningTimeMS, logoutTimeMS);
                }
            }, checkInterval);
        };
        checkLogoutTimeout = function(checkInterval, logoutTimeMS) {
            var logoutTimer = setTimeout(function() {
                var cookieTime = getCookieValue(timeoutCookieName);
                var cookieAge = getCookieAge(cookieTime);
                //alert(cookieAge + ' - ' + logoutTimeMS);
                if (cookieAge >= logoutTimeMS) {
                    window.location.href = contextLogout();
                } else {
                    checkLogoutTimeout(checkInterval, logoutTimeMS)
                }
            }, checkInterval);
        };

        checkWarningTimeout(checkInterval, warningTimeMS, logoutTimeMS);
        checkLogoutTimeout(checkInterval, logoutTimeMS);
	}

	function warnOfTimeout (warningTimeMS, logoutTimeMS) {
		timeoutModalOpen = true;
		var
			msCountdown = logoutTimeMS - warningTimeMS,
			secondsCountdown = msCountdown / 1000;

		$timeoutModal
			.modal({
				backdrop: 'static',
				keyboard: false
			})
			.css({
				'right': '0',
				'bottom': '0'
			});

		document.getElementById('timeRemaining').innerHTML = secondsCountdown;
		countDown(secondsCountdown);
	}

	function countDown (secondsCountdown) {

		ga('send','event','Session Timeout', 'start counter', { page : window.location.href });

		cookieRefreshed = false;
		var secondsRemaining = secondsCountdown;
		var countDownTimer = setInterval(function(){
			if (secondsRemaining > 0) {
				if (cookieRefreshed) {
					clearInterval(countDownTimer);
					return;
				}
				secondsRemaining--;
				document.getElementById('timeRemaining').innerHTML = secondsRemaining;
			}
			else {

				ga('send','event','Session Timeout', 'end counter', { page : window.location.href });

				clearInterval(countDownTimer);
				var cookieTime = getCookieValue(timeoutCookieName);
				var cookieAge = getCookieAge(cookieTime);
				if (cookieAge > timeToLogoutMS) {
					$timeoutModal.modal('hide');
				}
			}
		}, 1000);
	}

	function getCookieValue (cookieName) {
		var
			name = cookieName + '=',
		    cookieArray = document.cookie.split(';');

		for (var i = 0; i < cookieArray.length; i++) {
			var cookie = cookieArray[i];
			while (cookie.charAt(0) == ' ') {
                cookie = cookie.substring(1);
            }
			if (cookie.indexOf(name) == 0) {
                return cookie.substring(name.length, cookie.length);
            }
		}
		//return cookieStartClient ? cookieStartClient : '';
	}

	function getCookieAge (cookieTime) {
		var currentTime = new Date().getTime().toString();
        //alert(currentTime);
		var timeElapsed = currentTime - cookieTime;
        //alert('getCookieAge = (' + currentTime + ' - ' + cookieTime + ')' );
		return timeElapsed;
	}

	// get context_path from logout button in modal and prefix session expired url with it
	function contextLogout () {
        /*
	        var $logoutButton = $('[href$="logout"]').first().length ? $('[href$="logout"]').first() : $('.logout-link:eq(0)');
			var logoutUrl = $logoutButton.attr('href');
			var endOfContextPath = logoutUrl.lastIndexOf("/");
			var contextPath = logoutUrl.slice(0, endOfContextPath);
		*/

		return (CONTEXT_PATH + '/logged_out/session_expired');
	}

    function requestSessionProlongation() {
        if (! userIsActive) {
            return false;
        }

        $.ajax({
            url: CONTEXT_PATH + "/test/prolong_session",
            timeout: 5000,
            cache: false,

            success: function(data) {
                userIsActive = false;
                if (data == 'in') {
                    // do nothing here, cookie have been updated and that's enough

                    //var iFrameArray = document.getElementsByTagName('IFRAME');
                    //if (iFrameArray.length > 0) {
                    //    iFrameArray[0].contentWindow.location.reload();
                    //}

                }
                else {
                    //window.location.href = contextLogout();
                }
            },
            error: function(){
                window.setTimeout(requestSessionProlongation, 5000);
                //window.location.href = contextLogout();
            }
        });

    }


	function attachAodaHandlers() {
		window.setTimeout(function() {
			$timeoutModal.find('.aodaDialog').attr('aria-label', $timeoutModal.find('h4').text() + '. ' + $timeoutModal.find('.timeoutWarningText').text());
		}, 500);

		setTimeout(function () {
			aodaHandlerIntervalId = setInterval(function() {
				$timeoutModal.find('.aodaDialog').attr('aria-label', $('#sessionTimeoutRemainingText').text());
			}, 5000);
		}, 5000);

	}


	function detachAodaHandlers() {
		setTimeout(function() {
			aodaHandlerIntervalId && clearInterval(aodaHandlerIntervalId);
		}, 1000);
	}



});